<template>
  <div class="from_box">
    <el-form ref="ruleFormRef" :model="formData" :rules="rules" :inline="true" :disabled="formDisabled">
      <template v-for="item in formList">
        <slot v-if="item.slotName" :name="item.slotName" />

        <el-form-item v-if="item.type === 'input'" :label="item.label" :prop="item.key" :key="item.key">
          <el-input
            v-if="item.isNumber"
            class="myinput"
            v-model="formData[item.key]"
            oninput="value=value.replace(/[^\d]/g,'')"
            :placeholder="item.placeholder && !formDisabled ? item.placeholder : ''"
            :disabled="item.disabled ? item.disabled : false"
            :clearable="item.clearable ? item.clearable : false"
          ></el-input>
          <el-input
            v-else
            class="myinput"
            v-model="formData[item.key]"
            :placeholder="item.placeholder && !formDisabled ? item.placeholder : ''"
            :disabled="item.disabled ? item.disabled : false"
            :clearable="item.clearable ? item.clearable : false"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="item.type === 'number'" :label="item.label" :prop="item.key" :key="item.key">
          <el-input-number
            v-model="formData[item.key]"
            :min="item.min ? item.min : -Infinity"
            :max="item.max ? item.max : Infinity"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item
          v-if="item.type === 'textarea'"
          :style="{ width: item.width ? item.width : '' }"
          :label="item.label"
          :prop="item.key"
          :key="item.key"
        >
          <el-input
            v-model="formData[item.key]"
            :autosize="{ minRows: item.minRows ? item.minRows : 2, maxRows: item.maxRows ? item.maxRows : 4 }"
            type="textarea"
            :placeholder="item.placeholder && !formDisabled ? item.placeholder : ''"
            :clearable="item.clearable ? item.clearable : false"
          ></el-input>
        </el-form-item>
        <el-form-item v-else-if="item.type === 'select'" :label="item.label" :prop="item.key" :key="item.key">
          <!-- {{ item.optionList }} -->
          <el-select
            v-model="formData[item.key]"
            :filterable="item.isfilterable == 1 ? true : false"
            @change="(val) => changeSelect(val, item.key, item)"
            :disabled="item.disabled ? item.disabled : false"
            :placeholder="item.placeholder && !formDisabled ? item.placeholder : ' '"
            :clearable="item.clearable ? item.clearable : false"
          >
            <el-option
              v-for="opt in item.optionList"
              :key="opt.value || opt.id || opt.valueName || opt.brandNo"
              :label="opt.labelName || opt.label || opt.name"
              :value="opt.valueName || opt.value || opt.brandNo || opt.id"
              :disabled="opt.disabled ? opt.disabled : false"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else-if="item.type === 'cascader'" :label="item.label" :prop="item.key" :key="item.key">
          <el-cascader
            v-model="formData[item.key]"
            :options="item.optionList"
            :show-all-levels="false"
            :placeholder="item.placeholder && !formDisabled ? item.placeholder : ' '"
            :props="{
              value: item.valueName,
              label: item.labelName,
            }"
            @change="(val) => handleCascaderChange(val, item.key)"
          ></el-cascader>
        </el-form-item>
        <el-form-item v-else-if="item.type === 'timeDay'" :label="item.label" :prop="item.key" :key="item.key">
          <el-date-picker
            v-model="formData[item.key]"
            type="date"
            value-format="YYYY-MM-DD"
            :placeholder="item.placeholder && !formDisabled ? item.placeholder : ''"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-else-if="item.type === 'datetime'" :label="item.label" :prop="item.key" :key="item.key">
          <el-date-picker
            v-model="formData[item.key]"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="item.placeholder && !formDisabled ? item.placeholder : ''"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-else-if="item.type === 'datetimerange'" :label="item.label" :prop="item.key" :key="item.key">
          <el-date-picker
            v-model="formData[item.key]"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :default-time="[new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)]"
            :range-separator="item.range - separator ? item.range - separator : '至'"
            :start-placeholder="item.startPlaceholder && !formDisabled ? item.startPlaceholder : '开始日期'"
            :end-placeholder="item.endPlaceholder && !formDisabled ? item.endPlaceholder : '结束日期'"
            :clearable="item.clearable ? item.clearable : false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-else-if="item.type === 'radioGroup'" :label="item.label" :prop="item.key" :key="item.type">
          <el-radio-group v-model="formData[item.key]">
            <el-radio v-for="radio in item.radioList" :key="radio.label" :label="radio.label">{{ radio.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-else-if="item.type === 'switch'" :label="item.label" :prop="item.key" :key="item.key">
          <el-switch v-model="formData[item.key]" />
        </el-form-item>
        <el-form-item v-else-if="item.type === 'checkBox'" :label="item.label" :prop="item.key" :key="item.key">
          <el-checkbox-group v-model="formData[item.key]" @change="handleChangeCheckBox">
            <el-checkbox
              :label="check.label"
              v-for="(check, index) in item.checkBoxList"
              :key="index"
              :disabled="check.disabled ? check.disabled : false"
            />
          </el-checkbox-group>
        </el-form-item>
      </template>

      <el-form-item>
        <el-button type="primary" v-if="issubmitForm" class="button" @click="submitForm(ruleFormRef)">查询</el-button>
      </el-form-item>
      <el-form-item class="button2">
        <slot name="from"></slot>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { defineEmits, defineExpose, ref } from "vue";
const props = defineProps({
  formData: {
    //formData数据，非必填
    type: Object,
    required: false,
    default: () => [],
  },
  formList: {
    type: Array,
    required: true,
    default: () => [],
  },
  rules: {
    type: Object,
    required: false,
    default: () => {
      //
    },
  },
  inline: {
    type: Boolean,
    required: true,
    default: () => true,
  },
  formDisabled: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  issubmitForm: {
    type: Boolean,
    default: true,
  },
});
// 定义要emit的方法
const emit = defineEmits(["handleCascaderChange", "changeSelect"]);
// 初始化表单
const setFormData = () => {
  const result = {};
  props.formList.forEach((item) => {
    if (["cascader", "checkBox"].includes[item.type]) {
      result[item.key] = item.default ? item.default : [];
    } else if (item.type === "switch") {
      result[item.key] = item.default ? item.default : false;
    } else if (item.type === "number") {
      result[item.key] = item.min ? item.min : 0;
    } else {
      result[item.key] = item.default || item.default === 0 ? item.default : "";
    }
  });
  return result;
};
const formData = Object.keys(props.formData).length ? ref(props.formData) : ref(setFormData());
const ruleFormRef = ref(null);

// 明确要暴露出去的属性,使得父组件能接收到数据
defineExpose({
  state: {
    formData,
    ruleFormRef, // 校验表单时候使用
  },
});
const submitForm = (val) => {
  emit("submitForm", formData);
};

const handleCascaderChange = (value, key) => {
  console.log(value, 999);
  formData.value[key] = value;
  emit("handleCascaderChange", key, value);
};
const changeSelect = (value, key, item) => {
  // console.log(item);

  emit("changeSelect", key, value);
};

const handleChangeCheckBox = (val) => {
  console.log(val, 21836217);
};
</script>

<style lang="less" scoped>
.from_box {
  width: 100%;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
  // max-height: 115px;
}
.button {
  width: 60px;
  height: 30px;
  background: #0981ff;
  border-radius: 15px;
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #ffffff;
  line-height: 34px;
  text-align: center;
  border: none;
  margin-left: 20px;
}

.button:hover {
  background: #0980ffbd;
}
:deep(.el-input__wrapper) {
  border-radius: 16px;
}
:deep(.el-input__inner) {
  border-radius: 16px;
  padding-right: 0px !important;
}
.myinput {
  width: 214px;
}
// /deep/.el-input__inner {
//   // width: 200px;
//   height: 32px;
//   background: #f9fbfd;
//   border: 1px solid #c1d1ff;
//   border-radius: 16px;
//   font-size: 12px;
//   font-family: FZLanTingHei-M-GBK;
//   font-weight: 400;
//   line-height: 34px;
//   &::placeholder {
//     color: #a1a4af;
//   }
// }
// /deep/.el-input__inner:focus {
//   // width: 200px;
//   height: 32px;
//   background: #f9fbfd;
//   border: 1px solid #0981ff;
//   border-radius: 16px;
//   font-size: 12px;
//   font-family: FZLanTingHei-M-GBK;
//   font-weight: 400;
//   line-height: 34px;
//   &::placeholder {
//     color: #a1a4af;
//   }
// }
// /deep/.el-input__inner:hover {
//   // width: 200px;
//   height: 32px;
//   background: #f9fbfd;
//   border: 1px solid #a1c0ff;
//   border-radius: 16px;
//   font-size: 12px;
//   font-family: FZLanTingHei-M-GBK;
//   font-weight: 400;
//   line-height: 34px;
//   &::placeholder {
//     color: #a1a4af;
//   }
// }
:deep(.el-range-editor) {
  width: 320px !important;
  font-size: 12px;
  height: 32px !important;
  border-radius: 16px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  padding-right: 10px !important;
  &::placeholder {
    color: #a1a4af;
  }
}
:deep(.el-form-item) {
  margin-right: 10px;
}
:deep(.el-form-item__label) {
  padding: 0 8px 0 0px !important;
}
// :deep(.el-input__inner) {
//   padding-right: 0 !important;
// }
</style>
